import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PlayerContext } from '../App';
import DevotionalThumbnail from '../components/DevotionalThumbnail';
import { fetchChannelVideos } from '../youtube';

export default function VideoDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setCurrentTrack, setQueue, setQueueIdx } = useContext(PlayerContext);
  const [videos, setVideos] = useState([]);
  const [video, setVideo]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchChannelVideos()
      .then(all => {
        setVideos(all);
        const found = all.find(v => v.id === id);
        if (!found) navigate('/');
        else setVideo(found);
      })
      .catch(() => navigate('/'))
      .finally(() => setLoading(false));
  }, [id, navigate]);

  const playVideo = (v, allVids) => {
    const list = allVids || videos;
    const idx  = list.findIndex(x => x.id === v.id);
    setQueue(list);
    setQueueIdx(idx >= 0 ? idx : 0);
    setCurrentTrack(v);
  };

  if (loading || !video) {
    return (
      <div className="show-detail">
        <div style={{ padding: '20px 32px' }}>
          <div className="skeleton" style={{ width: 60, height: 14, marginBottom: 24 }} />
          <div style={{ display: 'flex', gap: 22, alignItems: 'flex-end' }}>
            <div className="skeleton" style={{ width: 200, height: 120, borderRadius: 12, flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div className="skeleton" style={{ width: '70%', height: 28, marginBottom: 10 }} />
              <div className="skeleton" style={{ width: '90%', height: 12, marginBottom: 18 }} />
              <div className="skeleton" style={{ width: 140, height: 36, borderRadius: 20 }} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const related = videos.filter(v => v.id !== id);

  return (
    <div className="show-detail">

      {/* ── Banner ── */}
      <div className="show-banner">
        {/* Devotional art as blurred banner background */}
        <div className="show-banner-bg" style={{ overflow: 'hidden', filter: 'blur(0px)' }}>
          <DevotionalThumbnail id={video.id} showTitle={false} style={{ filter: 'blur(4px)', transform: 'scale(1.05)' }} />
        </div>
        <div className="show-banner-overlay" />
        <div className="show-banner-content">
          <button className="back-btn" onClick={() => navigate(-1)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15,18 9,12 15,6"/></svg>
            Back
          </button>
          <div className="show-banner-inner">
            {/* Square devotional art for the album cover */}
            <div className="show-art" style={{ overflow: 'hidden', borderRadius: 14 }}>
              <DevotionalThumbnail id={video.id} showTitle={false} />
              <div className="show-art-glow" />
            </div>
            <div className="show-meta">
              <div className="show-cat-tag">{video.channelTitle}</div>
              <h1 className="show-title">{video.title}</h1>
              {video.description && (
                <p className="show-desc">
                  {video.description.length > 200 ? video.description.slice(0, 200) + '…' : video.description}
                </p>
              )}
              <div className="show-actions">
                <button className="hero-btn-primary" onClick={() => playVideo(video, videos)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>
                  Play Now
                </button>
                <div className="show-ep-count">{related.length + 1} Tracks</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── More Music ── */}
      {related.length > 0 && (
        <div className="episodes-section">
          <div className="episodes-section-title">More Music</div>
          <div className="episodes-list">
            {related.slice(0, 20).map(v => (
              <div key={v.id} className="ep-item" onClick={() => navigate(`/show/${v.id}`)}>
                <div className="ep-thumb">
                  <DevotionalThumbnail id={v.id} showTitle={false} />
                </div>
                <div className="ep-info">
                  <div className="ep-num">{v.channelTitle}</div>
                  <div className="ep-title">{v.title}</div>
                </div>
                <div className="ep-right">
                  <button className="ep-play-icon" onClick={(e) => { e.stopPropagation(); playVideo(v, videos); }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
